import React, { useState } from 'react';
import { Input } from 'reactstrap';

type Field = {
  id: number;
  companyName: string | undefined;
};

type BuyWish = {
  companyName: string;
};

type Props = {
  defaultData: Array<BuyWish>;
};

const convertToFields = (buyWishes: Array<BuyWish>): Array<Field> => {
  return buyWishes.map((buyWish, i) => ({
    id: i,
    companyName: buyWish.companyName,
  }));
};

export default function InputOtherVentureCompaniesView({ defaultData }: Props) {
  const [fields, setFields] = useState<Array<Field>>(
    convertToFields(defaultData),
  );

  const onAddField = () => {
    let nextID = 0;
    if (fields.length > 0) {
      nextID = fields[fields.length - 1].id + 1;
    }

    setFields([
      ...fields,
      {
        id: nextID,
        companyName: undefined,
      },
    ]);
  };

  const onRemoveField = (id: number) => {
    setFields(fields.filter(c => c.id !== id));
  };

  return (
    <div className="input-buy-form-wrapper">
      {fields.map(field => (
        <fieldset
          key={field.id}
          id={`othre_company_to_buy_${field.id}`}
          className="fieldset-row"
        >
          <Input
            name={`market_demand_questionnaire[other_venture_stock_wishes_attributes][${field.id}][company_name]`}
            className="company-name-input"
            type="text"
            defaultValue={field.companyName}
            placeholder="その他ベンチャー企業の銘柄"
            onKeyDown={event => {
              if (event.key === 'Enter') {
                event.preventDefault();
              }
            }}
          />
          <button
            type="button"
            onClick={() => onRemoveField(field.id)}
            className="icon-button"
          >
            <i className="fas fa-minus-circle" />
          </button>
        </fieldset>
      ))}
      <button
        type="button"
        onClick={() => onAddField()}
        className="icon-button"
      >
        <i className="fas fa-plus-circle" />
      </button>
    </div>
  );
}
